import jwtDecode from 'jwt-decode';
import type { TokenSet } from 'openid-client';
import { setAuthToken, setLogoutToken } from '@/modules/auth/utils';
import { toBoolean } from '@/utils/string';
import { getPasscodeAndAuthenticatorByUID } from '@/modules/auth/utils/passcode-authenticator';
import type { IAuthTokenCookie, IRequestResponse } from '../types';

/**
 * Process token set from OpenID response, set cookies, and return the auth token
 *
 * @param context - Server-side context (req, res)
 * @param tokenSet - Token set response from OpenID
 * @returns Processed auth token object
 */
export const processTokenSet = async (
  context: IRequestResponse,
  tokenSet: TokenSet
): Promise<IAuthTokenCookie> => {
  const { access_token, id_token, refresh_token, expires_at } = tokenSet;

  if (!access_token) {
    throw new Error('دیتای ارسالی صحیح نیست');
  }

  const { national_id: uid, national_id_verified } =
    jwtDecode<any>(access_token);

  const expiresAt: number = Number(expires_at) * 1000;

  const isNeedRegistered = !toBoolean(national_id_verified);

  const authToken: IAuthTokenCookie = {
    uid,
    token: access_token,
    expiresAt,
    isNeedRegistered,
    isNeedPasscode: !!getPasscodeAndAuthenticatorByUID(context.req, uid),
    refreshToken: refresh_token,
  };

  setAuthToken(context, authToken, {});

  if (id_token) {
    setLogoutToken(context.res, { idtoken: id_token });
  }

  return authToken;
};
